<template>
  <div>
    <div class="row mb-2 pe-4">
      <div class="col-lg-12 col-md-12 col-12 d-flex align-items-center">
        <div class="color-common">
          <h3 class="title-page mb-0 ps-3">MEGAPOS DATA</h3>
        </div>
      </div>
    </div>
    <div class="page-header align-items-start min-vh-100 my-transacions">
      <span class="mask bg-white"></span>
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-12 mx-auto mt-4">
            <div class="row">
              <strong>
                Paid Online Orders Report
              </strong>
            </div>
            <div class="row mt-3">
              <div class="col-lg-3 col-md-12 col-12">
                <div class="form-group">
                  <label class="text-bold">Physical Branch <span class="text-danger">*</span></label>
                  <div>
                    <Multiselect
                      v-model="branch_id"
                      :options="branchs"
                      :canClear="false"
                    />
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-12 col-12">
                <div class="form-group">
                  <label class="text-bold">From</label>
                  <div>
                    <Datepicker
                      :enableTimePicker="false"
                      class="date-time-dashboad"
                      v-model="from_date"
                      :format="format"
                      auto-apply
                      :clearable="false"
                      :min-date="new Date(new Date().setFullYear(new Date().getFullYear() - 1))"
                      :max-date="new Date()"
                      @update:model-value="onChangeFromDate"
                    />
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-12 col-12">
                <div class="form-group">
                  <label class="text-bold">To <span class="text-danger">(Up to 60 days)</span></label>
                  <div>
                    <Datepicker
                      :enableTimePicker="false"
                      class="date-time-dashboad"
                      v-model="to_date"
                      :format="format"
                      auto-apply
                      :clearable="false"
                      :min-date="from_date"
                      :max-date="new Date(new Date(from_date).setDate(new Date(from_date).getDate() + this.totalDaySelect))"
                      @update:model-value="onChangeToDate"
                    />
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-12 col-12">
                <div class="form-group">
                  <label class="text-bold">Status</label>
                  <div>
                    <Multiselect
                      v-model="status"
                      :options="statusArr"
                      :canClear="false"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex align-items-center mt-3">
              <div class="text-bold me-3">
                Search
              </div>
              <div style="width: 100%; max-width: 500px;">
                <input
                  class="nosubmit"
                  type="search"
                  id="keyword_search"
                  v-model="searchKeyword"
                  extraClass
                  name="keyword_search"
                  placeholder="Enter Branch Name/ID, Member Name, Email, ID..."
                  @keydown.enter="handleSearchEnter"
                />
              </div>
            </div>
            <div class="row mt-4 ps-3">
              <div class="col-lg-9 col-md-9 col-3 d-flex">
                <div class="dropdown">
                  <button
                    class="btn btn-secondary dropdown-toggle btn-sm"
                    type="button"
                    id="dropdownMenuButton1"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    aria-haspopup="true"
                    :disabled="disabled"
                  >
                    Download
                  </button>
                  <ul
                    class="dropdown-menu"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <li>
                      <a
                        class="dropdown-item"
                        @click="exportFile('csv')"
                        href="#"
                      >
                        Export CSV
                      </a>
                    </li>
                    <li>
                      <a
                        class="dropdown-item"
                        @click="exportFile('xlsx')"
                        href="#"
                      >
                        Export Excel
                      </a>
                    </li>
                    <li>
                      <a
                        class="dropdown-item"
                        @click="exportFile('pdf')"
                        href="#"
                        >Export PDF</a
                      >
                    </li>
                  </ul>
                </div>
                <div style="margin-left: 3vh;">
                  <material-button
                    class="btn-background btn-sm"
                    @click="filterData()"
                    style="width: 162.52px"
                  >
                    Run
                  </material-button>
                </div>
              </div>
            </div>
            <div class="row mt-1 ps-3">
              <div class="col-lg-9 col-md-12 col-12 d-flex justify-content-lg-start align-items-end">
                Count: {{ totalRecords }}
              </div>
              <div class="col-lg-3 col-md-3 col-3 d-flex justify-content-end">
                <ShowHideColumn
                  :columns="columns"
                  :changeCheckbox="changeCheckbox"
                  :columnCheckedCache="columnChecked"
                  :key="key"
                />
              </div>
            </div>
            <div class="row mt-3 g-2 pos-summary">
              <div class="col-lg col-md-4 col-6">
                <div class="summary-card">
                  <span class="summary-icon icon-subtotal material-icons-round">receipt_long</span>
                  <div class="summary-content">
                    <div class="summary-label">SubTotal</div>
                    <div class="summary-value">{{ subTotal || '$ 0.00' }}</div>
                  </div>
                </div>
              </div>
              <div class="col-lg col-md-4 col-6">
                <div class="summary-card">
                  <span class="summary-icon icon-service material-icons-round">room_service</span>
                  <div class="summary-content">
                    <div class="summary-label">Service Charge</div>
                    <div class="summary-value">{{ serviceChargeAmount || '$ 0.00' }}</div>
                  </div>
                </div>
              </div>
              <div class="col-lg col-md-4 col-6">
                <div class="summary-card">
                  <span class="summary-icon icon-gst material-icons-round">percent</span>
                  <div class="summary-content">
                    <div class="summary-label">GST</div>
                    <div class="summary-value">{{ gstAmount || '$ 0.00' }}</div>
                  </div>
                </div>
              </div>
              <div class="col-lg col-md-4 col-6">
                <div class="summary-card">
                  <span class="summary-icon icon-discount material-icons-round">sell</span>
                  <div class="summary-content">
                    <div class="summary-label">Discount</div>
                    <div class="summary-value">{{ discountValue || '$ 0.00' }}</div>
                  </div>
                </div>
              </div>
              <div class="col-lg col-md-4 col-6">
                <div class="summary-card summary-card-total">
                  <span class="summary-icon icon-total material-icons-round">payments</span>
                  <div class="summary-content">
                    <div class="summary-label">Total</div>
                    <div class="summary-value">{{ totalAmount || '$ 0.00' }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-4" style="min-height: 1120px;">
              <div class="col-12">
                <div class="card-custom">
                  <div class="px-0 pb-2">
                    <div class="table-responsive p-0 custom-table">
                      <table class="table align-items-center mb-0">
                        <thead>
                          <tr>
                            <th
                              class="text-center font-weight-bolder w-5"
                              v-if="columnShowed.includes('row_no')"
                            >
                              Row No
                            </th>
                            <template
                              v-for="(item, index) in headersData"
                              :key="index"
                            >
                              <th class="text-center font-weight-bolder" v-if="columnShowed.includes(item.field)">
                                <span
                                  :class="[
                                    !!item.hasSortBy
                                      ? 'wrapper-sortby pointer'
                                      : '',
                                    ESortDirectionSelect.idx == (index + 1)
                                      ? ESortDirectionSelect.direction === ESortDirection.Desc
                                        ? 'sort-desc'
                                        : 'sort-asc'
                                      : '',
                                  ]"
                                  @click="
                                    () => {
                                      !!item.hasSortBy &&
                                        handleChangeSortColumn(index + 1);
                                    }
                                  "
                                >{{ item.label }}</span>
                              </th>
                            </template>
                          </tr>
                        </thead>
                        <tbody v-if="posTransactionData.length">
                          <tr
                            v-for="(value, key) in posTransactionData"
                            :key="key"
                            :id="'order-' + value.transaction_id"
                          >
                            <td
                              class="text-center text-xss w-5 d-flex align-items-center"
                              v-if="columnShowed.includes('row_no')"
                            >
                            <i class="material-icons-round opacity-10 show-order-info" @click="orderDetail(value)"
                              >add</i
                            >
                              <div class="mt-1">{{ key + 1 }}</div>
                            </td>
                            <td
                              class="text-center text-xss w-5"
                              v-if="columnShowed.includes('uuid')"
                            >
                              {{ value.uuid }}
                            </td>
                            <td
                              class="text-center text-xss w-5"
                              v-if="columnShowed.includes('receipt_no')"
                            >
                              {{ value.receipt_no }}
                            </td>
                            <td
                              class="text-left text-xss w-25"
                              v-if="columnShowed.includes('transaction_id')"
                            >
                              {{ value.transaction_id }}
                            </td>
                            <td
                              class="text-left text-xss w-25"
                              v-if="columnShowed.includes('stripe_id')"
                            >
                              {{ value.stripe_id }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('created_at_format')"
                            >
                              {{ value.created_at_format }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('updated_at_format')"
                            >
                              {{ value.updated_at_format }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('branch_name')"
                            >
                              {{ value.branch_name }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('member_id_format')"
                            >
                              {{ value.member_id_format }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('member_name')"
                            >
                              {{ value.member_name }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('member_email')"
                            >
                              {{ value.member_email }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('tier_name')"
                            >
                              {{ value.tier_name }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('total_amount_format')"
                            >
                              {{ value.total_amount_format }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('sub_total_format')"
                            >
                              {{ value.sub_total_format }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('discount_code')"
                            >
                              {{ value.discount_code }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('voucher_code')"
                            >
                              {{ value.voucher_code }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('amount_direct_deduct_format')"
                            >
                              {{ value.amount_direct_deduct_format }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('topup_direct_deduct_format')"
                            >
                              {{ value.topup_direct_deduct_format }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('bonus_cashback_direct_deduct_format')"
                            >
                              {{ value.bonus_cashback_direct_deduct_format }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('topup_promotion_format')"
                            >
                              {{ value.topup_promotion_format }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('discount_label')"
                            >
                              {{ value.discount_label }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('discount_value_format')"
                            >
                              {{ value.discount_value_format }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('service_charge_amount_format')"
                            >
                              {{ value.service_charge_amount_format }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('gst_amount_format')"
                            >
                              {{ value.gst_amount_format }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('cess_amount_format')"
                            >
                              {{ value.cess_amount_format }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('take_away_charge_amount_format')"
                            >
                              {{ value.take_away_charge_amount_format }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('status')"
                            >
                              {{ value.status }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('dining_option')"
                            >
                              {{ value.dining_option }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('is_cutlery')"
                            >
                              {{ value.is_cutlery }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('customer_remark')"
                            >
                              {{ value.customer_remark }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('guest')"
                            >
                              {{ value.guest }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('tag')"
                            >
                              {{ value.tag }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('note')"
                            >
                              {{ value.note }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('table_remarks')"
                            >
                              {{ value.table_remarks }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('foc_remarks')"
                            >
                              {{ value.foc_remarks }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('operation_id')"
                            >
                              {{ value.operation_id }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('rounding')"
                            >
                              {{ value.rounding }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('payment_method')"
                            >
                              {{ value.payment_method }}
                            </td>
                          </tr>
                        </tbody>
                        <tbody v-else>
                          <tr>
                            <td colspan="29" class="text-center">
                              No item available
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="d-flex justify-content-between align-items-center mb-3 px-3 pt-3">
                    <div class="rows-per-page">
                      <span class="rows-per-page__label">Rows per page</span>
                      <div class="rows-per-page__control">
                        <select v-model="limit" @change="setLimitPerPage" class="rows-per-page__select">
                          <option :value="20">20</option>
                          <option :value="50">50</option>
                          <option :value="100">100</option>
                        </select>
                      </div>
                    </div>
                    <pagination
                      v-if="pagination.last_page > 1"
                      :pagination="pagination"
                      :current_page="pagination.current_page"
                      :last_page="pagination.last_page"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="position-fixed top-1 end-1 z-index-2 message-success">
        <material-snackbar
          v-if="snackbar === 'danger' || snackbar === 'success'"
          title=""
          date=""
          :description="message"
          :icon="{ component: 'campaign', color: 'white' }"
          :color="snackbar"
          :close-handler="closeSnackbar"
        />
      </div>
      <material-loading :active="loaderActive" />
    </div>
    <form
      :action="`${actionDownload}/merchant/download-online-ordering-report`"
      method="POST"
    >
      <input type="hidden" name="merchantId" :value="merchantIdExport" />
      <input type="hidden" name="merchant_code" :value="merchantCode" />
      <input type="hidden" name="token" :value="token" />
      <input type="hidden" name="list_field_show" :value="columnShowed" />
      <input type="hidden" name="search_keyword" :value="searchKeyword" />
      <input type="hidden" name="time_type" :value="time_type" />
      <input type="hidden" name="from_date" :value="dateFormat(from_date)" />
      <input type="hidden" name="to_date" :value="dateFormat(to_date)" />
      <input type="hidden" name="physical_branch_id" :value="branch_id" />
      <input type="hidden" name="status" :value="status" />
      <input type="hidden" name="checkExport" :value="checkExport" />
      <input type="hidden" name="action_export" :value="action_export" />
      <input type="hidden" name="type" :value="ONLINE_ORDER" />
      <input type="hidden" name="action" value="export" />
      <input id="downloadForm" type="submit" class="d-none" />
    </form>
  </div>
</template>

<script>
import MaterialSnackbar from '@/components/MaterialSnackbar.vue'
import 'bootstrap/dist/js/bootstrap.bundle'
import MaterialLoading from '@/components/MaterialLoading.vue'
import Pagination from '@/components/Pagination.vue'
import 'bootstrap/js/dist/modal'
import '@vuepic/vue-datepicker/dist/main.css'
import Multiselect from '@vueform/multiselect'
import '@vueform/multiselect/themes/default.css'
import MaterialButton from '@/components/MaterialButton.vue'
import ShowHideColumn from '@/components/ShowHideColumn.vue'
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import moment from 'moment'
import DashboardReportService from '../../services/dashboardReport.service'
import $ from 'jquery'
import TokenService from '../../services/token.service'
import CommonFunctionService from "../../services/commonFunction.service";
import { ONLINE_ORDER, mergeDeductedBonusCashbackColumns } from '@/config/utils'

export default {
  name: 'campaign-list',
  components: {
    MaterialSnackbar,
    MaterialLoading,
    MaterialButton,
    Pagination,
    Multiselect,
    Datepicker,
    ShowHideColumn
  },
  data() {
    return {
      token: TokenService.getLocalAccessToken(),
      actionDownload: process.env.VUE_APP_BASE_URL,
      merchantIdExport: localStorage.getItem("MERCHANT_ID", ""),
      merchantCode: localStorage.getItem('MERCHANT_CODE', ''),
      message: '',
      snackbar: null,
      loaderActive: false,
      searchKeyword: '',
      searchTimerId: null,
      pagination: {},
      page: 1,
      columns: [
        { value: 'all', label: 'All' },
        { value: 'row_no', label: 'Row No' },
        { value: 'uuid', label: 'UUID' },
        { value: 'receipt_no', label: 'Receipt No' },
        { value: 'transaction_id', label: 'Transaction ID' },
        { value: 'stripe_id', label: 'Stripe ID' },
        { value: 'created_at_format', label: 'Order Date Time' },
        { value: 'updated_at_format', label: 'Last Updated' },
        { value: 'branch_name', label: 'Channel' },
        { value: 'member_id_format', label: 'Member ID' },
        { value: 'member_name', label: 'Member Name' },
        { value: 'member_email', label: 'Member Email' },
        { value: 'tier_name', label: 'Tier' },
        { value: 'total_amount_format', label: 'Total Amount' },
        { value: 'sub_total_format', label: 'Sub Total' },
        { value: 'discount_code', label: 'Discount Code' },
        { value: 'voucher_code', label: 'Voucher Code' },
        { value: 'amount_direct_deduct_format', label: 'Deducted Amount' },
        { value: 'topup_direct_deduct_format', label: 'Deducted Topup' },
        { value: 'bonus_cashback_direct_deduct_format', label: 'Deducted Cashback/Bonus' },
        { value: 'topup_promotion_format', label: 'Topup Promotion' },
        { value: 'discount_label', label: 'Discount Label' },
        { value: 'discount_value_format', label: 'Discount Value' },
        { value: 'service_charge_amount_format', label: 'Service Charge' },
        { value: 'gst_amount_format', label: 'GST' },
        { value: 'cess_amount_format', label: 'Cess' },
        { value: 'take_away_charge_amount_format', label: 'Take Away Charge' },
        { value: 'status', label: 'Status' },
        { value: 'dining_option', label: 'Dining Option' },
        { value: 'is_cutlery', label: 'Cutlery' },
        { value: 'customer_remark', label: 'Customer Remark' },
        { value: 'guest', label: 'Guest' },
        { value: 'tag', label: 'Tag' },
        { value: 'note', label: 'Note' },
        { value: 'table_remarks', label: 'Table Remarks' },
        { value: 'foc_remarks', label: 'Foc Remarks' },
        { value: 'operation_id', label: 'Operation ID' },
        { value: 'rounding', label: 'Rounding' },
        { value: 'payment_method', label: 'Payment Method' },
      ],
      reward_type: 0,
      time_type: 9,
      times: [
        { value: 0, label: 'Select Time' },
        { value: 1, label: 'Today' },
        { value: 2, label: 'Yesterday' },
        { value: 3, label: 'Last 7 days' },
        { value: 4, label: 'Last 30 days' },
        { value: 5, label: 'This month' },
        { value: 6, label: 'Last 3 months' },
        { value: 7, label: 'This year' },
        { value: 8, label: 'Last year' },
        { value: 9, label: 'Custom' },
      ],
      from_date: new Date(),
      to_date: new Date(),
      isShowTimeCustom: false,
      action: 'list',
      action_export: 'csv',
      totalRecords: 0,
      columnShowed: [],
      branchs: [],
      branch_id: 0,
      posTransactionData: [],
      columnChecked: [],
      checkExport: false,
      statusArr: [],
      status: '',
      ESortDirectionSelect: {
        idx: null,
        direction: null
      },
      ESortDirection: {
        Asc: "asc",
        Desc: "desc",
      },
      totalDaySelect: 60,
      ONLINE_ORDER,
      limit: 20,
      subTotal: 0,
      totalAmount: 0,
      serviceChargeAmount: 0,
      gstAmount: 0,
      discountValue: 0,
    }
  },
  created() {
    this.getDataFilter()
    if (this.$route.query.page) {
      this.page = this.$route.query.page
    }
    if(window.localStorage.getItem("OnlineOrderingColumn")){
      this.columnChecked = mergeDeductedBonusCashbackColumns(
        window.localStorage.getItem("OnlineOrderingColumn").split(","),
        "bonus_direct_deduct_format",
        "cashback_direct_deduct_format",
        "bonus_cashback_direct_deduct_format"
      );
      this.key = Math.random();
    }
  },
  computed: {
    headersData() {
      return [
        {
          label: "UUID",
          field: "uuid",
          hasSortBy: true,
        },
        {
          label: "Receipt No",
          field: "receipt_no",
          hasSortBy: true,
        },
        {
          label: "Transaction ID",
          field: "transaction_id",
          hasSortBy: true,
        },
        {
          label: "Stripe ID",
          field: "stripe_id",
          hasSortBy: true,
        },
        {
          label: "Order Date Time",
          field: "created_at_format",
          hasSortBy: true,
        },
        {
          label: "Last Updated",
          field: "updated_at_format",
          hasSortBy: true,
        },
        {
          label: "Channel",
          field: "branch_name",
          hasSortBy: true,
        },
        {
          label: "Member ID",
          field: "member_id_format",
          hasSortBy: true,
        },
        {
          label: "Member Name",
          field: "member_name",
          hasSortBy: true,
        },
        {
          label: "Member Email",
          field: "member_email",
          hasSortBy: true,
        },
        {
          label: "Tier",
          field: "tier_name",
        },
        {
          label: "Total Amount",
          field: "total_amount_format",
          hasSortBy: true,
        },
        {
          label: "Sub Total",
          field: "sub_total_format",
          hasSortBy: true,
        },
        {
          label: "Discount Code",
          field: "discount_code",
          hasSortBy: true,
        },
        {
          label: "Voucher Code",
          field: "voucher_code",
          hasSortBy: true,
        },
        {
          label: "Deducted Amount",
          field: "amount_direct_deduct_format",
          hasSortBy: true,
        },
        {
          label: "Deducted Topup",
          field: "topup_direct_deduct_format",
          hasSortBy: true,
        },
        {
          label: "Deducted Cashback/Bonus",
          field: "bonus_cashback_direct_deduct_format",
        },
        // Was "Deducted Cashback" (merged above). Kept so sortCol indexes still line up with BE SORT_COL_*.
        { label: "", field: null },
        {
          label: "Topup Promotion",
          field: "topup_promotion_format",
          hasSortBy: true,
        },
        {
          label: "Discount Label",
          field: "discount_label",
        },
        {
          label: "Discount Value",
          field: "discount_value_format",
          hasSortBy: true,
        },
        {
          label: "Service Charge",
          field: "service_charge_amount_format",
          hasSortBy: true,
        },
        {
          label: "GST",
          field: "gst_amount_format",
          hasSortBy: true,
        },
        {
          label: "Cess",
          field: "cess_amount_format",
          hasSortBy: true,
        },
        {
          label: "Take Away Charge",
          field: "take_away_charge_amount_format",
          hasSortBy: true,
        },
        {
          label: "Status",
          field: "status",
          hasSortBy: true,
        },
        {
          label: "Dining Option",
          field: "dining_option",
        },
        {
          label: "Cutlery",
          field: "is_cutlery",
        },
        {
          label: "Customer Remark",
          field: "customer_remark",
        },
        {
          label: "Guest",
          field: "guest",
        },
        {
          label: "Tag",
          field: "tag",
        },
        {
          label: "Note",
          field: "note",
        },
        {
          label: "Table Remarks",
          field: "table_remarks",
        },
        {
          label: "Foc Remarks",
          field: "foc_remarks",
        },
        {
          label: "Operation ID",
          field: "operation_id",
        },
        {
          label: "Rounding",
          field: "rounding",
        },
        {
          label: "Payment Method",
          field: "payment_method",
        },
      ];
    },
  },
  methods: {
    format(date) {
      return CommonFunctionService.formatDateShow(date)
    },

    onChangeFromDate(from_date) {
      this.from_date = from_date;
      let limitDate = moment(from_date).add(this.totalDaySelect, 'days');
      
      if (moment(this.to_date) > limitDate || moment(this.to_date) < moment(this.from_date)) {
        if (limitDate > moment()) {
          limitDate = moment();
        }

        this.to_date = from_date;
      }
    },

    onChangeToDate(to_date) {
      this.to_date = to_date;

      // if (this.totalDaySelect) {
        // const limitDate = moment(to_date).subtract(this.totalDaySelect, 'days');
        
        // if (moment(this.from_date) < limitDate) {
          // this.from_date = limitDate;
          // this.onChangeSearchParameter(this.from_date, this.search_field.FROM_DATE);
        // }
      // }
    },

    exportFile(type = 'csv') {
      if (this.columnShowed.length == 0) {
        this.snackbar = 'danger'
        this.message = 'You must select least 1 column to export file.'
        this.setTimeOutNotification()
      } else {
        this.action_export = type
        setTimeout(() => {
          $('#downloadForm').click()
        }, 150)
      }
    },

    changeCheckbox(columnShowed) {
      this.columnShowed = columnShowed
      window.localStorage.setItem("OnlineOrderingColumn", columnShowed)
    },

    timeChange($event) {
      if ($event == 9) {
        this.isShowTimeCustom = true
      } else {
        this.isShowTimeCustom = false
      }
    },

    filterData() {
      this.getList(this.page)
    },

    dateFormat(date) {
      if (date == null) {
        return null
      } else {
        return moment(date).format('YYYY-MM-DD')
      }
    },

    orderDetail(order) {
      var orderDetailElement = $('.order-detail.order-' + order.transaction_id)

      if (orderDetailElement.length) {
        orderDetailElement.remove();
        $('#order-' + order.transaction_id + ' i.show-order-info').html('add');
      } else {
        this.showLoader();
        var dataForm = {
          transaction_id: order.transaction_id,
          type: ONLINE_ORDER
        };

        DashboardReportService.getOrderDetail(dataForm).then(
          async (response) => {
            if (response.data.result.isSuccess) {
              $('#order-' + order.transaction_id + ' i.show-order-info').html('remove');
              $('#order-' + order.transaction_id).after(response.data.data);
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification();
            }
            this.hideLoader();
          },
          (error) => {
            this.snackbar = "danger";
            this.message = error;
            this.hideLoader();
            this.setTimeOutNotification();
          }
        );
      }
    },

    closeSnackbar() {
      this.snackbar = null
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null
      }, 3000)
    },

    handleChangeSortColumn(idx) {
      if (this.ESortDirectionSelect.idx && this.ESortDirectionSelect.idx == idx) {
        this.ESortDirectionSelect.direction = this.ESortDirectionSelect.direction === this.ESortDirection.Asc ? this.ESortDirection.Desc : this.ESortDirection.Asc;
      } else {
        this.ESortDirectionSelect = {
          idx: idx,
          direction: this.ESortDirection.Asc
        }
      }
      
      if (this.posTransactionData.length) {
        this.getList(this.page);
      }
    },

    getList(page) {
      this.totalRecords = 0
      this.showLoader()
      var dataForm = {
        action: this.action,
        physical_branch_id: this.branch_id,
        search_keyword: this.searchKeyword,
        time_type: this.time_type,
        from_date: this.dateFormat(this.from_date),
        to_date: this.dateFormat(this.to_date),
        type: ONLINE_ORDER,
        action_export: this.action_export,
        checkExport: this.checkExport,
        status: this.status,
        page: page,
        sortCol: this.ESortDirectionSelect.idx,
        sortType: this.ESortDirectionSelect.direction,
        limit: this.limit,
      }

      $('.order-detail').remove();
      $('.show-order-info').html('add');

      DashboardReportService.getDataOnlineOrderingReport(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.posTransactionData = response.data.data.data.items || []
            this.pagination = response.data.data.data || {}
            this.page = this.pagination.current_page || 1
            this.totalRecords = this.pagination.total || 0
            this.subTotal = response.data.data.sub_total || 0
            this.totalAmount = response.data.data.total_amount || 0
            this.serviceChargeAmount = response.data.data.service_charge_amount || 0
            this.gstAmount = response.data.data.gst_amount || 0
            this.discountValue = response.data.data.discount_value || 0
            if (this.pagination.current_page > this.pagination.last_page) {
              this.page = 1
              this.getList(this.page)
            }
            this.$router.push({
              query: Object.assign({}, this.$route.query, { page: this.page }),
            })
            this.checkExport = true;
          } else {
            this.snackbar = 'danger'
            this.message = response.data.result.message
            this.setTimeOutNotification()
          }
          this.hideLoader()
        },
        (error) => {
          this.snackbar = 'danger'
          this.message = error
          this.hideLoader()
          this.setTimeOutNotification()
        },
      )
    },

    setLimitPerPage() {
      // Reset to page 1 when changing limit
      this.page = 1;
      this.getList(1);
    },

    showLoader() {
      this.loaderActive = true
    },

    hideLoader() {
      this.loaderActive = false
    },

    getDataFilter() {
      this.showLoader()
      DashboardReportService.getFilterDataTopupReport().then(
        (response) => {
          if (response.data.result.isSuccess) {
            var DataFilter = response.data.data
            this.branchs = DataFilter.physicalBranches;
            this.statusArr = response.data.data.status;
            if (this.statusArr && typeof this.statusArr === 'object') {
              delete this.statusArr[""];
            }
            this.status = "1";
          } else {
            this.snackbar = 'danger'
            this.message = response.data.result.message
            this.setTimeOutNotification()
          }
          this.hideLoader()
        },
        (error) => {
          this.snackbar = 'danger'
          this.message = error
          this.hideLoader()
          this.setTimeOutNotification()
        },
      )
    },

    handleSearchEnter(){
      this.getList(this.page);
    },
  },
}
</script>
<style scoped>
table thead th:not(:first-child) {
  min-width: 150px;
}

table thead th > span {
  position: relative;
}

input[type='search'] {
  border: none;
  background: transparent;
  margin: 0;
  padding: 7px 8px;
  font-size: 14px;
  color: inherit;
  border: 1px solid transparent;
  border-radius: inherit;
}

input[type='search']::placeholder {
  color: #bbb;
  text-align: left;
  font-weight: normal;
}

input[type='search']:focus {
  border-color: #72959d;
  outline: none;
  border: none;
  border-bottom: 2px solid #72959d;
}

.nosubmit-parent {
  border: none;
  padding: 0;
}

input.nosubmit {
  border-bottom: 1px solid #d2d2d2;
  width: 100%;
  padding: 9px 4px 9px 40px;
  background: transparent
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' class='bi bi-search' viewBox='0 0 16 16'%3E%3Cpath d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z'%3E%3C/path%3E%3C/svg%3E")
    no-repeat 13px center;
}

.date-time-dashboad .dp__input_wrap {
  min-width: 200px !important;
  width: 250px;
}

.custom-control-label label {
  padding-top: 14px !important;
}

.pt-custtom {
    padding-top: 7px;
}

.show-order-info {
  font-size: 20px !important;
  font-weight: bold;
  color: #007bff;
  cursor: pointer;
}

/* Summary cards */
.pos-summary .summary-card {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  height: 100%;
  padding: 16px;
  border: 1px solid #eef0f3;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 6px 20px rgba(20, 45, 82, 0.06);
  transition: box-shadow 0.15s ease, transform 0.15s ease;
}

.pos-summary .summary-card:hover {
  box-shadow: 0 10px 26px rgba(20, 45, 82, 0.1);
  transform: translateY(-2px);
}

.pos-summary .summary-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  color: #fff;
  font-size: 22px;
}

.pos-summary .icon-subtotal {
  background: linear-gradient(135deg, #4c7ef3, #6f9bff);
}

.pos-summary .icon-service {
  background: linear-gradient(135deg, #e08a3c, #f2b562);
}

.pos-summary .icon-gst {
  background: linear-gradient(135deg, #9b5de5, #c084f5);
}

.pos-summary .icon-discount {
  background: linear-gradient(135deg, #2f9e78, #38b6a0);
}

.pos-summary .icon-total {
  background: linear-gradient(135deg, #1f6f78, #38b6a0);
}

.pos-summary .summary-content {
  min-width: 0;
}

.pos-summary .summary-card-total {
  background: linear-gradient(135deg, #f3f6ff 0%, #eef7f4 100%);
  border-color: #cfe4e0;
}

.pos-summary .summary-label {
  font-size: 11px;
  color: #8392ab;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  line-height: 1.3;
  min-height: 30px;
}

.pos-summary .summary-value {
  margin-top: 4px;
  font-size: 20px;
  font-weight: 700;
  color: #1f2d3d;
  word-break: break-word;
}
</style>
